import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

/**
 * 
 * @param {object} props {
 * header {object} E.g. {label: 'Name', text: 'Some Text'}
 * rows {object[]} E.g. [{label: 'Label 1', text: 'The Text 1}, ...]
 * skipHeader {bool} Hide the table header.
 * rightColSx {object} styling right column
 * leftColSx {object} styling left column
 * @returns 
 */
export function DlspTable({header = {}, rows, leftColSx = {}, rightColSx = {}, skipHeader = false}) {
    
    return (
        <TableContainer component={Box}>
        <Table>
            {
                !skipHeader
                ?
                <TableHead>
                    <TableRow>
                        <TableCell align="right" sx={leftColSx}>{header.label || 'Label'}</TableCell>
                        <TableCell sx={rightColSx}>{header.text || 'Text'}</TableCell>
                    </TableRow>
                </TableHead>
                :
                null
            }
            <TableBody>
            {
                rows.map((row) => (
                    <TableRow key={row.label}>
                        <TableCell align="right" sx={leftColSx}>{row.label}</TableCell>
                        <TableCell sx={rightColSx}><strong>{row.text}</strong></TableCell>
                    </TableRow>
                )
            )}
            </TableBody>
        </Table>
        </TableContainer>
    )
}